module.exports = __webpack_public_path__ + "pl.svg?d3ef7ce00af81ce1aabd4344c2c792ee";